export const regularizacaoOPsStyle = {}
